import type { TableSearchParams } from "@rootline/ui/hooks";

export type ApiKeyAction = "copy" | "rotate" | "rename" | "expiration";
export type UserAction = "rename" | "roles";
export type WebhookAction = "configure" | "delete";

export type SettingsResourceSearch = TableSearchParams & {
  modal?: "create";
  apiKeyId?: string;
  apiKeyAction?: ApiKeyAction;
  userId?: string;
  userAction?: UserAction;
  webhookId?: string;
  webhookAction?: WebhookAction;
};

export function parseSettingsResourceSearch(
  search: Record<string, unknown>,
): SettingsResourceSearch {
  const apiKeyAction =
    search.apiKeyAction === "copy" ||
    search.apiKeyAction === "rotate" ||
    search.apiKeyAction === "rename" ||
    search.apiKeyAction === "expiration"
      ? search.apiKeyAction
      : undefined;
  const webhookAction =
    search.webhookAction === "configure" || search.webhookAction === "delete"
      ? search.webhookAction
      : undefined;

  return {
    pageSize: search.pageSize ? Number(search.pageSize) : undefined,
    sort: (search.sort as string) || undefined,
    filters: (search.filters as Record<string, unknown>) || undefined,
    columns: typeof search.columns === "string" ? search.columns : undefined,
    columnOrder:
      typeof search.columnOrder === "string" ? search.columnOrder : undefined,
    modal: search.modal === "create" ? "create" : undefined,
    apiKeyId: typeof search.apiKeyId === "string" ? search.apiKeyId : undefined,
    apiKeyAction,
    userId: typeof search.userId === "string" ? search.userId : undefined,
    userAction:
      search.userAction === "rename" || search.userAction === "roles"
        ? search.userAction
        : undefined,
    webhookId:
      typeof search.webhookId === "string" ? search.webhookId : undefined,
    webhookAction,
  };
}
